import { ReactSVG } from 'react-svg'

import { cn } from '@shared/lib/cn'
import { LocalizedLink as Link } from '@shared/lib/locale'

import styles from './styles.module.scss'



interface CardLinkProps {
  to: string;
  className?: string;
  children: React.ReactNode;
}

export default function CardLink (props: CardLinkProps) {
  const { to, className, children } = props

  return (
    <Link className={cn(styles.root, className)} to={to}>
      {children}

      <ReactSVG
        className={styles.root__icon}
        src="/icons/arrow-circle.svg"
        wrapper="span"
      />
    </Link>
  )
}
